import React from 'react';
import ConcertPartners from '../concert-partners/concert-partners';
import ImageRaw from '../../../../components/image-raw';
import Organizations from './components/organizations';
import ConcertPartnersMobile from '../concert-partners/concert-partners.mobile';
import {OrganizationAndPartnersProps} from './organization-and-partners.type';

const OrganizationAndPartnersDesktop: React.FC<OrganizationAndPartnersProps> = ({partners}) => {
    if (!partners) {
        return <></>;
    }

    return (
        <div className="relative w-full max-w-[2000px] h-full flex justify-end items-end pt-[50px]">
            {/* 10 seasons logo */}
            <div
                className="absolute hidden left-0 lg:!block z-20
            lg:!w-[460px] lg:!h-[396px]
            xl:!w-[460px] xl:!h-[396px] xl:!bottom-[0] xl:!left-[20px]
            2xl:!bottom-[2.1%] 2xl:aspect-[596/585] 2xl:!w-[596px] 2xl:!h-[446px]
            ">
                <ImageRaw
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/10-seasons-logo-v3.png"
                    alt="Logo 10 Seasons Concert"
                    className="object-contain"
                />
            </div>
            <div
                className="relative w-full max-w-[2000px] h-full pt-[80px] xl:!bg-center !bg-bottom bg-cover bg-no-repeat flex justify-end items-end "
                style={{
                    //backgroundImage:'url(https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/organization-and-partners-bg.png)',
                }}>
                <div className='absolute top-0 w-full z-0'>
                    <ImageRaw
                        src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/organization-and-partners-bg.png"
                        alt="organization-and-partners-bg"
                        className='h-full w-full object-scale-down'
                    />
                </div>
                <div className="h-full w-full max-w-[2000px] mx-auto flex flex-col justify-start items-center 2xl:!gap-[100px] gap-[50px] z-10">
                    <Organizations />
                    <div className='w-full bg-[#3B1CD9] pb-[100px]'>
                        <div className="w-[80%] !mx-auto">
                        <div className="lg:!block hidden">
                            <ConcertPartners partners={partners} containerClassName="2xl:!px-[94px] py-[35px]" />
                        </div>
                        <div className="lg:hidden">
                            <ConcertPartnersMobile partners={partners} containerClassName="py-[35px]" />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationAndPartnersDesktop;
